import React from 'react';
import { Box } from '@mui/material';

const BackgroundSVG: React.FC = () => {
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 800"
      preserveAspectRatio="xMidYMid slice"
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        zIndex: -10,
        minWidth: '100%',
        minHeight: '100vh',
        objectFit: 'cover',
      }}
    >
      {/* Fondo de cielo nocturno andino con degradado */}
      <defs>
        <linearGradient id="cieloNocturno" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#0B1328" />
          <stop offset="100%" stopColor="#1A2C4D" />
        </linearGradient>
      </defs>
      <rect width="1200" height="800" fill="url(#cieloNocturno)" />

      {/* Estrellas en el cielo nocturno andino */}
      {/* Estrellas pequeñas */}
      <circle cx="100" cy="80" r="1" fill="#FFFFFF" opacity="0.8" />
      <circle cx="220" cy="50" r="1" fill="#FFFFFF" opacity="0.7" />
      <circle cx="350" cy="70" r="1" fill="#FFFFFF" opacity="0.8" />
      <circle cx="450" cy="40" r="1" fill="#FFFFFF" opacity="0.9" />
      <circle cx="550" cy="90" r="1" fill="#FFFFFF" opacity="0.7" />
      <circle cx="650" cy="60" r="1" fill="#FFFFFF" opacity="0.8" />
      <circle cx="750" cy="30" r="1" fill="#FFFFFF" opacity="0.9" />
      <circle cx="850" cy="80" r="1" fill="#FFFFFF" opacity="0.8" />
      <circle cx="950" cy="50" r="1" fill="#FFFFFF" opacity="0.7" />
      <circle cx="1050" cy="70" r="1" fill="#FFFFFF" opacity="0.9" />
      <circle cx="1150" cy="40" r="1" fill="#FFFFFF" opacity="0.8" />

      <circle cx="150" cy="120" r="1" fill="#FFFFFF" opacity="0.8" />
      <circle cx="250" cy="100" r="1" fill="#FFFFFF" opacity="0.9" />
      <circle cx="380" cy="130" r="1" fill="#FFFFFF" opacity="0.7" />
      <circle cx="480" cy="110" r="1" fill="#FFFFFF" opacity="0.8" />
      <circle cx="580" cy="140" r="1" fill="#FFFFFF" opacity="0.9" />
      <circle cx="680" cy="90" r="1" fill="#FFFFFF" opacity="0.7" />
      <circle cx="780" cy="120" r="1" fill="#FFFFFF" opacity="0.8" />
      <circle cx="880" cy="100" r="1" fill="#FFFFFF" opacity="0.7" />
      <circle cx="980" cy="130" r="1" fill="#FFFFFF" opacity="0.9" />
      <circle cx="1080" cy="110" r="1" fill="#FFFFFF" opacity="0.8" />

      {/* Estrellas medianas */}
      <circle cx="180" cy="60" r="1.5" fill="#FFFFFF" opacity="0.9" />
      <circle cx="420" cy="90" r="1.5" fill="#FFFFFF" opacity="0.9" />
      <circle cx="620" cy="40" r="1.5" fill="#FFFFFF" opacity="0.8" />
      <circle cx="800" cy="70" r="1.5" fill="#FFFFFF" opacity="0.9" />
      <circle cx="1020" cy="50" r="1.5" fill="#FFFFFF" opacity="0.8" />
      <circle cx="300" cy="110" r="1.5" fill="#FFFFFF" opacity="0.9" />
      <circle cx="520" cy="80" r="1.5" fill="#FFFFFF" opacity="0.8" />
      <circle cx="720" cy="130" r="1.5" fill="#FFFFFF" opacity="0.9" />
      <circle cx="920" cy="60" r="1.5" fill="#FFFFFF" opacity="0.8" />
      <circle cx="1120" cy="90" r="1.5" fill="#FFFFFF" opacity="0.9" />

      {/* Algunas estrellas más brillantes */}
      <circle cx="200" cy="40" r="2" fill="#FFFFFF" opacity="1" />
      <circle cx="500" cy="70" r="2" fill="#FFFFFF" opacity="1" />
      <circle cx="850" cy="50" r="2" fill="#FFFFFF" opacity="1" />
      <circle cx="1100" cy="80" r="2" fill="#FFFFFF" opacity="1" />
      <circle cx="370" cy="120" r="2" fill="#FFFFFF" opacity="1" />
      <circle cx="650" cy="30" r="2" fill="#FFFFFF" opacity="1" />
      <circle cx="950" cy="100" r="2" fill="#FFFFFF" opacity="1" />

      {/* Efecto resplandor en algunas estrellas */}
      <circle cx="200" cy="40" r="3" fill="#FFFFFF" opacity="0.3" />
      <circle cx="500" cy="70" r="3" fill="#FFFFFF" opacity="0.3" />
      <circle cx="850" cy="50" r="3" fill="#FFFFFF" opacity="0.3" />
      <circle cx="1100" cy="80" r="3" fill="#FFFFFF" opacity="0.3" />
      <circle cx="370" cy="120" r="3" fill="#FFFFFF" opacity="0.3" />
      <circle cx="650" cy="30" r="3" fill="#FFFFFF" opacity="0.3" />
      <circle cx="950" cy="100" r="3" fill="#FFFFFF" opacity="0.3" />

      {/* Líneas de conexión tecnológica muy sutiles entre algunas estrellas */}
      <line x1="200" y1="40" x2="500" y2="70" stroke="#FFFFFF" strokeWidth="0.2" opacity="0.2" />
      <line x1="500" y1="70" x2="850" y2="50" stroke="#FFFFFF" strokeWidth="0.2" opacity="0.2" />
      <line x1="850" y1="50" x2="1100" y2="80" stroke="#FFFFFF" strokeWidth="0.2" opacity="0.2" />
      <line x1="1100" y1="80" x2="950" y2="100" stroke="#FFFFFF" strokeWidth="0.2" opacity="0.2" />
      <line x1="950" y1="100" x2="650" y2="30" stroke="#FFFFFF" strokeWidth="0.2" opacity="0.2" />
      <line x1="650" y1="30" x2="370" y2="120" stroke="#FFFFFF" strokeWidth="0.2" opacity="0.2" />
      <line x1="370" y1="120" x2="200" y2="40" stroke="#FFFFFF" strokeWidth="0.2" opacity="0.2" />

      {/* Montañas del altiplano en silueta - estilo simple */}
      {/* Capa lejana */}
      <path
        d="M0,400 L120,350 L200,380 L320,340 L400,390 L520,350 L600,370 L700,340 L820,380 L920,350 L1000,390 L1100,360 L1200,400 L1200,800 L0,800 Z"
        fill="#0D1D35"
        opacity="0.8"
      />

      {/* Capa intermedia */}
      <path
        d="M0,450 L150,420 L250,470 L350,430 L450,480 L550,430 L650,470 L750,420 L850,460 L950,410 L1050,450 L1150,420 L1200,450 L1200,800 L0,800 Z"
        fill="#0A1626"
        opacity="0.9"
      />

      {/* Capa cercana */}
      <path
        d="M0,500 L100,480 L200,530 L300,490 L400,540 L500,500 L600,550 L700,490 L800,530 L900,480 L1000,520 L1100,470 L1200,490 L1200,800 L0,800 Z"
        fill="#050A14"
      />

      {/* Ligero brillo en los bordes superiores de las montañas (luz estelar) */}
      <path
        d="M0,400 L120,350 L200,380 L320,340 L400,390 L520,350 L600,370 L700,340 L820,380 L920,350 L1000,390 L1100,360 L1200,400"
        stroke="#304878"
        strokeWidth="1"
        opacity="0.3"
        fill="none"
      />
    </Box>
  );
};

export default BackgroundSVG;
